import queryString from 'query-string';

import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { hrisImportLogsStateForMergeIntegrationIdSelector } from '../hris-import-log-selectors';

import { get } from '../../api/api';
import { HrisImportLog } from '../../typescript-types/hris-import-log';

export const loadHrisImportLogs = (mergeIntegrationId: number) =>
  createGenericDispatcher<Array<HrisImportLog>>({
    name: 'LOAD_HRIS_IMPORT_LOGS',
    loadFunction: () =>
      get(
        `/hris-import-log?${queryString.stringify({
          mergeIntegrationId,
        })}`,
      ),
    args: { mergeIntegrationId },
    shouldExecuteSelector: (state: any) =>
      hrisImportLogsStateForMergeIntegrationIdSelector(state, mergeIntegrationId),
  });
